import { AudioManager, AudioType } from '@colonist/audio';
export class UINotificationActionController {
    addNotificationsToPanel(notificationDataWithUnreadCount) {
        this.notificationPanel.addNotifications(notificationDataWithUnreadCount.notifications);
        this.notificationPanel.displayNumberOfUnreadNotifications(notificationDataWithUnreadCount.unreadNotificationCount);
        if (notificationDataWithUnreadCount.isExistingNotifications) return;
        AudioManager.play(AudioType.RoomSettingUpdated);
    }
    markNotificationAsRead(markedAsReadData) {
        this.notificationPanel.displayNumberOfUnreadNotifications(markedAsReadData.unreadNotificationCount);
        if (markedAsReadData.markAllAsRead) return this.notificationPanel.markAllNotificationsAsRead();
        if (markedAsReadData.notificationMarkedAsRead) return this.notificationPanel.markNotificationAsRead(markedAsReadData.notificationMarkedAsRead.id);
    }
    constructor(notificationPanel){
        this.notificationPanel = notificationPanel;
    }
}
